import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type AppVisibilityState = {
  isInForeground: boolean;
};

const initialState: AppVisibilityState = {
  isInForeground: true,
};

const appStateSlice = createSlice({
  name: "appState",
  initialState,
  reducers: {
    setAppInForeground: (state, action: PayloadAction<boolean>) => {
      state.isInForeground = action.payload;
    },
  },
});

export const { setAppInForeground } = appStateSlice.actions;
export default appStateSlice.reducer;
